const apiAddress = (() => {
    let dynURL;
    if (typeof document != "undefined") {
        if ((dynURL = document.URL)) {

            if (dynURL.search(/localhost/) >= 0) {
                return "http://localhost:3000";
            }

            if (dynURL.search(/wetware80/) >= 0) {
                return "https://ed-ws.wetware80.net";
            }
        }
    }
    return "";
})();

export default apiAddress;